import React from "react";

import ImageContentBlock from "./image";

class ImageContainer extends React.Component {
  constructor(props) {
    super(props);

    // arbitrary business logic
    this.fakeData = "fake data";
  }

  render() {
    return (
      <ImageContentBlock
        url={this.props.data.image.fields.file.url}
        handleImageCreate={this.props.handleImageCreate}
        handleImageLoaded={this.props.handleImageLoaded}
      />
    );
  }
}
export default ImageContainer;
